var _defs, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEsgUnableToLocate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 250 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 130.11,
    y1: -160.83,
    x2: 130.11,
    y2: -230.6,
    gradientTransform: "matrix(1 0 0 -1 0 -91.33)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b0bacc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969eae"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 131.93,
    y1: -126.29,
    x2: 131.93,
    y2: -285.87,
    gradientTransform: "matrix(1 0 0 -1 0 -91.33)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdfeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ecf0f5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 135.11,
    y1: -175.06,
    x2: 135.11,
    y2: -310.25,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#eaeef9}.cls-4{fill:#989fb0}.cls-5{fill:#d5ddea}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M132.89 237.96c62.26 0 112.74-50.48 112.74-112.96S195.15 12.04 132.89 12.04 20.15 62.51 20.15 125s50.48 112.96 112.74 112.96Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.94 65.18h160.33c6.45 0 11.34 4.89 11.34 11.34v101.62c0 6.45-4.89 11.34-11.34 11.34H49.94c-6.45 0-11.34-4.89-11.34-11.34V76.52c0-6.45 5.34-11.34 11.34-11.34Z",
    style: {
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m190.88 76.52 1.36 109.71c0 3.75-3.07 6.64-6.81 6.64H78.44c-3.75 0-6.81-3.07-6.81-6.64V45.17c0-3.75 3.07-6.64 6.81-6.64h77.51l34.92 37.99Z",
    style: {
      fill: "url(#linear-gradient-2)"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M140.96 61.52H89.68c-1.19 0-2.21-1.02-2.21-2.21s1.02-2.21 2.21-2.21h51.28c1.19 0 2.21 1.02 2.21 2.21s-1.02 2.21-2.21 2.21ZM109.44 73.79H89.68c-1.19 0-2.21-1.02-2.21-2.21s1.02-2.21 2.21-2.21h19.59c1.19 0 2.21 1.02 2.21 2.21s-1.02 2.21-2.04 2.21ZM155.95 38.52v30.32c0 4.26 3.75 7.67 8.01 7.67h26.92M176.6 99.7H90.32c-.79 0-1.59.8-1.59 1.91 0 .96.64 1.91 1.59 1.91h86.12c1.11 0 1.75-.8 1.75-1.91 0-.96-.63-1.91-1.59-1.91Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M224.73 130.34v50.03c0 6.45-5.11 11.79-11.79 11.79H48.16c-6.45 0-11.79-5.34-11.79-11.79v-54.26",
    style: {
      fill: "none",
      stroke: "#1676ee",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.72 102.32h-52.03c-5.11 0-10.01 1.78-13.79 4.89l-13.56 11.12c-3.78 3.11-8.67 4.89-13.79 4.89H58.84c-6 0-10.9 4.89-10.9 10.9 0 .44 0 1.11.22 1.56l10.9 57.37c.89 5.34 5.34 9.34 10.9 9.34H195.6c5.34 0 10.01-3.78 10.9-9.12l15.12-78.5c1.11-6-2.89-11.34-8.89-12.45h-2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.06 86.97h-67.6c-6.67 0-12.9 2.22-18.01 6.45l-17.79 14.45c-4.89 4-11.34 6.45-18.01 6.45H36.16c-7.78 0-14.01 6.45-14.01 14.01 0 .67 0 1.33.22 2l14.01 74.94c1.11 7.11 7.12 12.23 14.01 12.23h163.66c7.12 0 12.9-4.89 14.01-12.01l19.79-102.51c1.34-7.78-3.78-14.68-11.56-16.23-.67.22-1.56.22-2.22.22Z",
    style: {
      fill: "url(#linear-gradient-3)"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M242.3 79.45c4.25 0 7.7-3.45 7.7-7.7s-3.45-7.7-7.7-7.7-7.7 3.45-7.7 7.7 3.45 7.7 7.7 7.7ZM234.6 54.47a5.26 5.26 0 1 0 0-10.52 5.26 5.26 0 0 0 0 10.52ZM21.6 71.75c2.9 0 5.26-2.35 5.26-5.26s-2.35-5.26-5.26-5.26-5.26 2.35-5.26 5.26 2.35 5.26 5.26 5.26ZM9.77 187.45c5.39 0 9.77-4.37 9.77-9.77s-4.37-9.77-9.77-9.77S0 172.28 0 177.68s4.37 9.77 9.77 9.77Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m231.81 232.17-32.67-32.61c-34.48 25.36-81.76.63-81.76-40.76 0-28.17 22.96-50.99 51.09-50.99 40.66 0 65.61 45.65 41.93 80.15l32.85 32.79a8.016 8.016 0 0 1 0 11.41 8.058 8.058 0 0 1-11.43 0Zm-63.34-108.14c-19.24 0-34.94 15.67-34.94 34.87 0 30.88 37.03 45.74 58.26 25.9 24.05-22.46 7.98-60.77-23.32-60.77Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M164.93 166.51c-.09-.72-.18-1.45-.18-2.26 0-2.99 1.27-5.71 4.45-8.06l2.72-1.99c1.72-1.27 2.45-2.72 2.45-4.44 0-2.54-1.81-4.98-5.63-4.98s-5.72 3.17-5.72 6.34c0 .63.09 1.27.18 1.81l-7.08-.27c-.18-.81-.27-1.72-.27-2.54 0-6.07 4.54-11.86 12.8-11.86 8.71 0 13.25 5.43 13.25 11.14 0 4.44-2.27 7.52-5.54 9.87l-2.27 1.63c-1.99 1.36-2.99 3.17-2.99 5.43v.36h-6.17v-.18Zm3.18 3.62c2.45 0 4.45 1.99 4.45 4.44s-2 4.44-4.45 4.44-4.45-1.99-4.45-4.44 2-4.44 4.45-4.44Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsgUnableToLocate);
export default __webpack_public_path__ + "static/media/esg_unable-to-locate.c36922c398e47344906cfebfb70a0ff1.svg";
export { ForwardRef as ReactComponent };